import React from 'react';
import format from 'date-fns/format';
import toDate from 'date-fns/toDate';
import cx from 'classnames';

import nlLocale from 'date-fns/locale/nl';
import deLocale from 'date-fns/locale/de';
import enLocale from 'date-fns/locale/en-US';

import styles from './styles.scss';

export default class DatePicker extends React.PureComponent {
  onChange = () => {
    const day = parseInt(this.day.value);
    const result = this.getDate(this.year.value, this.month.value, day > 0 ? day : 1);
    this.props.onChange(result);
  };

  getDate = (year, month, day) => {
    return format(new Date(year, month, day), 'YYYY-MM-DD');
  };

  render() {
    const { label, value, name } = this.props;
    const p = this.props;
    const thisYear = new Date().getFullYear();
    const parsedDate = toDate(value);
    const validDate = isFinite(parsedDate);
    const date = validDate ? parsedDate : new Date();
    const setYear = date.getFullYear();
    const setMonth = validDate ? date.getMonth() : 0;
    const setDay = validDate ? date.getDate() : -1;
    const languages = {
      nl: nlLocale,
      de: deLocale,
      en: enLocale,
    };

    const days = [
      <option key={0} value={-1}>
        -
      </option>,
    ];
    for (let day = 1; day <= 31; day++) {
      days.push(
        <option key={day} value={day}>
          {day}
        </option>
      );
    }

    const years = [];
    for (let year = thisYear + 1; year > thisYear - 10; year--) {
      years.push(
        <option key={year} value={year}>
          {year}
        </option>
      );
    }

    return (
      <div className={cx(styles.input, p.className, styles.datepicker)}>
        <input type="hidden" name={name} value={this.getDate(setYear, setMonth, setDay)} />

        {label ? <label>{label}</label> : null}

        <div className={styles.group}>
          <div className={styles.select}>
            <select ref={c => (this.day = c)} onChange={this.onChange} value={setDay}>
              {days}
            </select>
            <span className={styles.arrow}>▾</span>
          </div>
          <div className={styles.select}>
            <select ref={c => (this.month = c)} onChange={this.onChange} value={setMonth}>
              {Array.from({ length: 12 }, (_, i) =>
                format(new Date(2023, i, 1), 'MMMM', { locale: languages[kroostApp.language] })
              ).map((month, i) => (
                <option key={i} value={i}>
                  {month}
                </option>
              ))}
            </select>
            <span className={styles.arrow}>▾</span>
          </div>
          <div className={styles.select}>
            <select ref={c => (this.year = c)} onChange={this.onChange} value={setYear}>
              {years}
            </select>
            <span className={styles.arrow}>▾</span>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/form/datepicker.js